import {Component, OnInit} from '@angular/core';
import {FileUploadModule} from 'primeng/fileupload';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ConfirmationService, MessageService, Message} from 'primeng/api';
import {Arquivo} from 'src/app/shared/models/arquivo.model';
import {first} from 'rxjs/operators';
import {AutorizacaoService} from 'src/app/services/autorizacao.service';
import {AutenticacaoService} from 'src/app/services/autenticacao.service';
import {NgAnimateScrollService} from 'ng-animate-scroll';
import {SharedService} from "../../../services/shared.service";
import { Router } from '@angular/router';
import { BusinessService } from 'src/app/services/business.service';
import { BeneficiarioService } from 'src/app/services/beneficiario.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-nova-solicitacao',
  templateUrl: './nova-solicitacao.component.html',
  styleUrls: ['./nova-solicitacao.component.scss'],
  providers: [FileUploadModule, MessageService, ConfirmationService]
})
export class NovaSolicitacaoComponent implements OnInit {

  msgs: Message[] = [];
  novaSolicitacao: FormGroup;
  loading: boolean;
  ufs: any[] = [];
  cdUsuario: any;
  cdEmpresa: any;
  nmArquivo: any;
  mostraProtocolo: any;
  files: any[] = [];
  arquivo: Arquivo;
  arrayFiles: any[] = [];
  protocolo: any;
  encodedString: any[] = [];
  teste: any;
  ufSelected: any = '';
  ufSigla: any = '';
  enviado = false;
  uploadedFiles: any[] = [];
  cidadesFiltradas: string[];
  cidades: string[] = [];
  minLengthToFilter: number = 3;

  isFeriadoOuDesabilitado: boolean = false;
  mensagemFeriadoOuDesabilitado: String = '';

  exibeAvisoAuto: boolean = false;
  mensagemAuto: SafeHtml = '';

  exibeAvisoArqWeb: boolean = false;
  mensagemArqWeb: SafeHtml = '';

  constructor(private router: Router, private fb: FormBuilder, private autenticacaoService: AutenticacaoService,
              private autorizacaoService: AutorizacaoService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private animateScrollService: NgAnimateScrollService,
              private sharedService: SharedService,
              private beneficiarioService: BeneficiarioService,
              private sanitizer: DomSanitizer,
              private businessService: BusinessService) {
  }

  ngOnInit() {
    this.loading = false;
    this.novaSolicitacao = this.fb.group({
      'cdUsuario': new FormControl(''),
      'listaArquivos': new FormControl(''),
      'nuFone': new FormControl('', Validators.compose([Validators.pattern('^\\(?\\d{2}\\)?[\\s-]?[\\s9]?\\d{4}-?\\d{4}$'), Validators.required])),
      'dsEmail': new FormControl('', Validators.compose([Validators.required, Validators.email])),
      'cdUf': new FormControl('', Validators.required),
      'nmCidade': new FormControl('', Validators.required),
      'dsPrestador': new FormControl('')
    });
    this.cdUsuario = this.sharedService.beneficiario.cdUsuario;
    this.cdEmpresa = this.sharedService.beneficiario.cdFilial;
    this.verificaAutoWeb();
    this.buscaFeriadoOuDesabilitado();
    this.buscaListaUFs();
    this.buscaInfoBeneficiario();

  }

  get f() {
    return this.novaSolicitacao.controls;
  }

  buscaListaUFs() {
    this.loading = true;
    this.autorizacaoService.buscaListaUFs()
      .pipe(first())
      .subscribe(res => {
          this.ufs = res;
          this.loading = false;
          //return this.updateListaUFs(res);
        },
        error => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erro ao carregar lista de Estados. Tente novamente em alguns instantes!',
            life: 9999999
          });
        }
      );
  }

  buscaListaCidades(cdUF: string) {
    this.loading = true;
    this.autorizacaoService.buscaListaCidades(cdUF).pipe(first()).subscribe(res => {
      this.loading = false;
      this.cidades = res;
    })
  }

  buscaInfoBeneficiario() {
    this.loading = true;
    this.autorizacaoService.buscaInfoBeneficiario(this.cdUsuario)
      .pipe(first())
      .subscribe(res => {
          this.loading = false;
          return this.updateInfoBeneficiario(res);
        },
        error => {
          this.loading = false;
        }
      );
  }

  updateInfoBeneficiario(res: any): void {
    this.novaSolicitacao.get('nuFone').setValue(res.nuFone);
    this.novaSolicitacao.get('dsEmail').setValue(res.dsEmail);
    this.ufSelected = res.nmUf;
    this.ufSigla = res.cdUf;
    this.buscaListaCidades(this.ufSigla);
  }

  uploadArquivo(element) {
    this.files = [];
    this.arrayFiles = [];
    this.encodedString = [];
    this.files = element.files;
    for (let file of this.files) {
      this.setArquivoBase64(file);
    }
    this.configuraArquivo();
    this.verificaArqWeb();
  }

  setArquivoBase64(file) {
    var reader = new FileReader();
    reader.onload = this.handleReaderLoaded.bind(this);
    reader.readAsBinaryString(file);
  }

  handleReaderLoaded(e) {
    let reader = e.target;
    let fileResult = reader.result;
    this.encodedString.push(btoa(fileResult));
  }

  onSubmit() {
    if (this.validacoes()) {
      this.salvaSolicitacao();
      this.animateScrollService.scrollToElement('sucesso', 300);
    }

    this.enviado = true;
    if (this.novaSolicitacao.invalid) {
      return;
    }
  }

  listenerUF(event) {
    this.novaSolicitacao.get('cdUf').setValue(event.target.options[event.target.options.selectedIndex].value);
    this.novaSolicitacao.get('nmCidade').setValue('');
    this.buscaListaCidades(event.target.options[event.target.options.selectedIndex].value);
  }

  verificaUF() {
    if (!this.novaSolicitacao.get('cdUf').value || this.ufSelected === this.novaSolicitacao.get('cdUf').value) {
      this.novaSolicitacao.get('cdUf').setValue(this.ufSigla);
    }
  }

  validacoes() {
    this.messageService.clear();
    let check = true;

    this.verificaUF();

    if (this.novaSolicitacao.status === 'INVALID') {
      this.messageService.add({severity: 'warn', summary: 'Preencha todos os campos corretamente', life: 7000});
      check = false;
    }
    if (this.files.length == 0) {
      this.messageService.add({severity: 'warn', summary: 'Anexe pelo menos um arquivo', life: 7000});
      check = false;
    }
    return check;
  }

  salvaSolicitacao() {
    this.messageService.clear();
    this.configuraArquivo();
    this.novaSolicitacao.get('cdUsuario').setValue(this.cdUsuario);
    this.novaSolicitacao.get('listaArquivos').setValue(this.arrayFiles);
    this.loading = true;

    this.autorizacaoService.salvaSolicitacao(this.novaSolicitacao.value).pipe(first()).subscribe(res => {
        this.loading = false;
        if (res.todosArquivosSalvo) {
          return this.updateProtocolo(res.solicitacao);
        } else {
          this.confirmationService.confirm({
            message: 'Sua Solicitação foi salva, entretanto os arquivos abaixo não foram salvos <br/>'
              + res.arquivosNaoSalvos.replace('\n', '<br/>'),
            header: 'Solicitacao Salva',
            icon: 'pi pi-info-circle',
            acceptLabel: 'OK',
            rejectVisible: false,
            accept: () => {
              return this.updateProtocolo(res.solicitacao);
            },
          });
        }
      },
      error => {
        this.loading = false;
        if (error === 'Unknown Error') {
          this.messageService.add({
            severity: 'error',
            summary: 'Estamos com problemas. Tente novamente em alguns instantes!',
            life: 9999999
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Problema ao salvar solicitação, por gentileza, tente novamente',
            life: 9999999
          });
        }
      }
    );
  }

  updateProtocolo(res) {
    this.protocolo = res;
    this.mostraProtocolo = !this.mostraProtocolo;
  }

  configuraArquivo() {
    this.arrayFiles = [];
    this.files.forEach((file, i) => {
      this.arquivo = new Arquivo();
      this.arquivo.arquivoBase64 = this.encodedString[i];
      this.arquivo.nmArquivo = this.getNomeSemExtencao(file.name);
      this.arquivo.extensaoArquivo = this.getFileExtension(file.name);
      this.arquivo.cdUsuario = this.cdUsuario;
      this.nmArquivo = this.arquivo.nmArquivo + "." + this.arquivo.extensaoArquivo;
      this.arrayFiles.push(this.arquivo);
    });
  }

  getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
  }

  getNomeSemExtencao(filename) {
    return filename.split('.').slice(0, -1).join('.');
  }

  voltar(visualizaListaSolicitacoes: boolean) {
    this.sharedService.visualizaListaSolicitacoes = visualizaListaSolicitacoes;
    this.router.navigate(['/solicitacoes']);
  }

  logout() {
    var businessId = this.autenticacaoService.logout();
    this.router.navigate(['/login'],{queryParams:{cod_empresa:businessId}});
  }

  removerArquivo(event: any) {
    this.encodedString.splice(this.files.indexOf(event.file), 1);
  }

  filtraCidades(event: any) {
    this.cidadesFiltradas = [];
    this.cidades.forEach(cidade => {
      if (cidade.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
        this.cidadesFiltradas.push(cidade);
      }
    })
  }

  updateMensagemFeriadoOuDesabilitado(res) {
    this.mensagemFeriadoOuDesabilitado = res.mensagem;
    this.isFeriadoOuDesabilitado = (res.mensagem != null || res.mensagem.trim().length > 0) ;
  }

  getBusinessId() {
    return this.businessService.getBusinessId();
  }

  buscaFeriadoOuDesabilitado() {
    this.loading = true;
    const cdEmpresa = this.getBusinessId();
    this.autorizacaoService.buscaFeriadoOuDesabilitado(cdEmpresa)
      .pipe(first())
      .subscribe(res => {
        this.updateMensagemFeriadoOuDesabilitado(res);
        if (this.isFeriadoOuDesabilitado) {
          this.router.navigate(['/solicitacoes']);
        }
      },
        error => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erro.Tente novamente em alguns instantes!',
            life: 9999999
          });
        }
      );
  }

  verificaAutoWeb(): boolean {
    this.beneficiarioService.verificaAutoWeb(this.cdUsuario).pipe(first()).subscribe(mensagem => {
      if(mensagem) {
        this.exibeAvisoAuto = true;
        this.mensagemAuto = this.sanitizer.bypassSecurityTrustHtml(mensagem.mensagem);
      }
    }, err => console.log(err));
    return true;
  }

  fecharMensagemAutoWeb() {
    this.exibeAvisoAuto = false;
  }

  verificaArqWeb(): boolean {
    this.beneficiarioService.verificaArqWeb(this.cdUsuario, this.nmArquivo).pipe(first()).subscribe(mensagem => {
      if(mensagem) {
        this.exibeAvisoArqWeb = true;
        this.mensagemArqWeb = this.sanitizer.bypassSecurityTrustHtml(mensagem.mensagem);
      }
    }, err => console.log(err));
    return true;
  }

  fecharMensagemArqWeb() {
    this.exibeAvisoArqWeb = false;
  }
}
